/**
 * Query-key factory. CONVENTION (see docs/frontend/CONVENTIONS.md):
 *
 *   [entity, 'list', params]   paginated/filtered lists
 *   [entity, 'detail', id]     single resource
 *   [entity, <custom>, ...]    anything else (e.g. ['reports','daily', range])
 *
 * Invalidate with the broad key (`queryKeys.users.all`) after any mutation so every list and detail
 * refetches. Each screen agent ADDS its own entity block below (append-only, alphabetical) or, to avoid
 * touching this file at all, defines `export const fooKeys = {...}` in its feature folder using the same shape.
 */
/**
 * Meal-period start times live in two places on the server (Settings > Meal periods and Kitchen Items > Meal times,
 * both backed by the `meal_period_times` setting). Whichever screen saves must refresh all of these.
 */
export const mealTimeDependentKeys = [
  ['settings'],
  ['kitchen', 'meal-times'],
  ['pos', 'meal-map'],
] as const;

export const queryKeys = {
  activityLogs: {
    all: ['activity-logs'] as const,
    list: (params: object) => ['activity-logs', 'list', params] as const,
  },
  auth: {
    me: ['auth', 'me'] as const,
  },
  settings: {
    all: ['settings'] as const,
  },
  users: {
    all: ['users'] as const,
    list: (params: object) => ['users', 'list', params] as const,
    detail: (id: number) => ['users', 'detail', id] as const,
  },
};
